import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { NgForm } from '@angular/forms';
import { Productcategory } from 'src/app/model/productcategory.model';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../../environments/environment';
import { isNull } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css']
})
export class AddproductComponent implements OnInit {

  product: Products;
  axProducts: any;
  category: Productcategory;
  productData: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  readonly rootUrl = environment.baseUrl;

  isAxProduct: boolean = false;
  isCustomProduct: boolean = false;

  constructor(private productServices: ProductService, private router: Router) {
    this.product = new Products();
  }

  ngOnInit() {
    this.getProductCategory();
    this.getAxProductList();
    this.product.outOfStock = false;
    this.isAxProduct = true;

    // this.dropdownList = [
    //   { item_id: 1, item_text: 'Mumbai' },
    //   { item_id: 2, item_text: 'Bangaluru' },
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' },
    //   { item_id: 5, item_text: 'New Delhi' }
    // ];
    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' }
    // ];
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'itemId',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  handleChange(evt) {
    var target = evt.target;
    if (target.checked) {
      console.log(target.value);
      if (target.value == "axproduct") {
        this.isAxProduct = true;
        this.isCustomProduct = false;
        this.product = new Products();
        this.product.outOfStock = false;
      }
      else {
        this.isCustomProduct = true;
        this.isAxProduct = false;
        this.product = new Products();
        this.product.outOfStock = false;
      }
    } else {

    }
  }

  onItemSelect(item: any) {
    //console.log(item);

    this.productData = this.axProducts.filter(x => x.itemId == item.itemId)[0];
    if (this.productData != null) {
      this.product.productName = this.productData.name;
      this.product.unitsPerCase = this.productData.mpSalesPerCase;
      this.product.productDescription = this.productData.mpPackSizeCode;

    }
  }

  onDeSelectAll(item: any) {
    this.product.productName = "";
    this.product.unitsPerCase = 0;
    this.product.productDescription = "";
  }

  // onSelectAll(items: any) {
  //   console.log(items);
  // }

  getProductCategory() {
    this.productServices.getProductCategory().subscribe(
      (data: any) => {
        this.category = data;
        console.log(this.category);
      }
    )
  }

  getAxProductList() {
    this.productServices.getAxProductList().subscribe(
      (data: any) => {
        this.axProducts = data;
        //console.log(this.axProducts);
      }
    )
  }

  // onSelectCode(itemCode) {

  //   this.productData = this.axProducts.filter(x => x.itemId == itemCode)[0];
  //   if (this.productData != null) {
  //     this.product.productName = this.productData.name;
  //     this.product.unitsPerCase = this.productData.mpSalesPerCase;
  //     this.product.productDescription = this.productData.mpPackSizeCode;

  //   }

  // }

  addProduct(form: NgForm) {


    debugger;
    if (this.isAxProduct) {
      form.value.productCode = form.value.productCode[0].itemId;
    }
    else {
      var regex = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
      if (!form.value.productCode.match(regex)) {
        alert("Product code must be alphanumeric");
        return false;
      }
    }
    console.log(form.value);
    if (form.value.outOfStock == "true") {
      form.value.outOfStock = true;
    }
    else {
      form.value.outOfStock = false;
    }
    form.value.unitsPerCase = parseInt(form.value.unitsPerCase);
    if(isNullOrUndefined(form.value.quantity))
    {
      form.value.quantity = 0;
    }
    form.value.quantity = parseInt(form.value.quantity);
    if (!form.value.productImage || form.value.productImage == null || form.value.productImage == "") {
      form.value.productImage = this.rootUrl + "/images/noimage.png";
    }

    if (!isNullOrUndefined(form.value.productCode)) {
      this.productServices.addProduct(form.value)
        .subscribe((data: any) => {
          if (data == true) {
            alert("Product added successfully");
            this.router.navigate(['/productlist']);
          }
          else {
            alert("Product code already exist");
          }
        });
    }

  }

}
